// ── Trend Sparkline — mini chart using Recharts ──

import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import type { TrendPoint } from "../types/graph";
import { severityColor } from "../utils/colors";

interface TrendSparklineProps {
  data: TrendPoint[];
}

export default function TrendSparkline({ data }: TrendSparklineProps) {
  const latest = data[data.length - 1];
  const color = latest ? severityColor(latest.avgSeverity) : "#3393ff";

  return (
    <div className="h-32 w-full bg-fl-sand-20 rounded-lg p-2">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 4, right: 4, bottom: 4, left: 4 }}>
          <defs>
            <linearGradient id="trendGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.4} />
              <stop offset="100%" stopColor={color} stopOpacity={0.05} />
            </linearGradient>
          </defs>
          <XAxis
            dataKey="period"
            tick={{ fill: "#798984", fontSize: 10 }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            domain={[0, 5]}
            tick={{ fill: "#798984", fontSize: 10 }}
            axisLine={false}
            tickLine={false}
            width={20}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              border: "1px solid rgba(31, 58, 50, 0.15)",
              borderRadius: "8px",
              backdropFilter: "blur(8px)",
              color: "#1f3a32",
              fontSize: 12,
            }}
            formatter={(value: number) => [value.toFixed(1), "Avg Severity"]}
          />
          <Area
            type="monotone"
            dataKey="avgSeverity"
            stroke={color}
            strokeWidth={2}
            fill="url(#trendGrad)"
            dot={{ fill: color, r: 3, strokeWidth: 0 }}
            activeDot={{ fill: color, r: 5, strokeWidth: 2, stroke: "#fff" }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
